/**
 * Petstyle24 Header – Mobile-Menü und Such-Panel.
 *
 * Menü: natives <dialog> über den gemeinsamen Dialog-Helfer aus ps-global.js
 * (Animation 320 ms, Esc, Scrim-Klick, Fokus zurück zum Auslöser). Fokusfalle und
 * inerter Hintergrund kommen vom Browser (showModal). Scroll-Lock: einziger Mechanismus
 * html:has(dialog[scroll-lock][open]) – hier kein eigener Lock.
 * Ohne ps-global.js (Fallback) öffnet und schließt das Menü sofort.
 *
 * Such-Panel: Mobile + Tablet (< 1024 px), Esc und „Suche schließen“ schließen,
 * der Fokus geht zurück zur Lupe.
 */
(() => {
  const header = document.querySelector('[data-site-header]');
  if (!header) return;

  const dialogs = window.Petstyle24 && window.Petstyle24.dialog;

  /* ---------- Such-Panel ---------- */
  const panel = header.querySelector('[data-search-panel]');
  const searchToggle = header.querySelector('[data-search-toggle]');

  const openSearch = () => {
    panel.hidden = false;
    searchToggle.setAttribute('aria-expanded', 'true');
    panel.querySelector('input')?.focus();
  };

  const closeSearch = (returnFocus = false) => {
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    searchToggle.setAttribute('aria-expanded', 'false');
    if (returnFocus) searchToggle.focus();
  };

  if (panel && searchToggle) {
    searchToggle.addEventListener('click', () => (panel.hidden ? openSearch() : closeSearch()));
    panel.querySelector('[data-search-close]')?.addEventListener('click', () => closeSearch(true));
    panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeSearch(true);
    });
    window.matchMedia('(min-width: 1024px)').addEventListener('change', (event) => {
      if (event.matches) closeSearch();
    });
  }

  /* ---------- Mobile-Menü ---------- */
  const menu = header.querySelector('[data-menu-drawer]');
  const menuToggle = header.querySelector('[data-menu-open]');
  if (!menu || !menuToggle) return;

  const openMenu = () => {
    closeSearch();
    if (dialogs) {
      dialogs.open(menu, menuToggle);
    } else if (!menu.open) {
      menu.showModal();
    }
    menuToggle.setAttribute('aria-expanded', 'true');
  };

  const closeMenu = () => {
    if (dialogs) {
      dialogs.close(menu);
    } else if (menu.open) {
      menu.close();
    }
  };

  menuToggle.addEventListener('click', openMenu);
  menu.addEventListener('close', () => menuToggle.setAttribute('aria-expanded', 'false'));
  menu.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', closeMenu));

  if (!dialogs) {
    // Klick auf den Scrim (::backdrop) trifft das <dialog> selbst
    menu.addEventListener('click', (event) => {
      if (event.target === menu) closeMenu();
    });
  }

  // Ab 768 px gibt es kein Mobile-Menü: sofort schließen, ohne Animation
  window.matchMedia('(min-width: 768px)').addEventListener('change', (event) => {
    if (event.matches && menu.open) menu.close();
  });
})();
